import React from 'react';
import useOffcanvasStore from "store/offcanvasStore";


const NoKhata = () => {
    const { openOffcanvas } = useOffcanvasStore();
    return (
        <div className="row h-100">
            <div className='col-12 my-auto text-center'>
                <i className="bi bi-people" style={{ fontSize: "7rem" }}/>
                <h3><i className="bi bi-arrow-left" style={{ fontSize: "1.4rem" }}/> Ledgers</h3>
                <p>Select a Khata to get started</p>
                <button
                    className="fs-6 btn btn-app p-3 mt-3 animate__animated animate__heartBeat"
                    onClick={() => openOffcanvas("newAccount", {})}
                    data-bs-target="#addAccountDrawer">
                        Create New Khata
                </button>
            </div>
        </div>
    )
}

export default NoKhata;